/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback } from "react";
import { usePlugins } from "../lib/react-query/usePlugins";

const usePluginUtils = () => {
  const { data: plugins } = usePlugins();

  const isPluginEnabled = useCallback(
    (pluginKey) => {
      // is_active is boolean now; "1"/1 kept for responses from not yet updated servers
      return (
        !!plugins &&
        plugins.some(
          (plugin) =>
            plugin.key === pluginKey && (plugin.is_active === true || plugin.is_active === "1" || plugin.is_active === 1)
        )
      );
    },
    [plugins]
  );

  return {
    isPluginEnabled,
  };
};

export default usePluginUtils;
